import { Navigate, createBrowserRouter, redirect } from 'react-router-dom';

import { AppLayout } from '@/components/layout/AppLayout';
import { HomeRedirect } from '@/components/layout/HomeRedirect';
import { RequireAuth } from '@/components/layout/RequireAuth';
import { LoginPage } from '@/pages/auth/LoginPage';
import { AnatelAcordaosPage } from '@/pages/anatel/AcordaosPage';
import { AnatelConselhoPage } from '@/pages/anatel/ConselhoPage';
import { AnatelConselhoCasesPage } from '@/pages/anatel/ConselhoCasesPage';
import { AnatelConselhoItemsPage } from '@/pages/anatel/ConselhoItemsPage';
import { AnatelConselhoMethodologyPage } from '@/pages/anatel/ConselhoMethodologyPage';
import { AnatelConsistencyPage } from '@/pages/anatel/ConsistencyPage';
import { AnatelDecisionsPage } from '@/pages/anatel/DecisionsPage';
import { AnatelDocumentsPage } from '@/pages/anatel/DocumentsPage';
import { AnatelEntitiesPage } from '@/pages/anatel/EntitiesPage';
import { AnatelEntityProfilePage } from '@/pages/anatel/EntityProfilePage';
import { AnatelInfracoesPage } from '@/pages/anatel/InfracoesPage';
import { AnatelOverviewPage } from '@/pages/anatel/OverviewPage';
import { AnatelPafCaseDetailPage } from '@/pages/anatel/PafCaseDetailPage';
import { AnatelPafDecisionsPage } from '@/pages/anatel/PafDecisionsPage';
import { AnatelPafConsistencyPage } from '@/pages/anatel/PafConsistencyPage';
import { AnatelPafOverviewPage } from '@/pages/anatel/PafOverviewPage';
import { AnatelConselheiroPage } from '@/pages/anatel/ConselheiroPage';
import { AnatelProcessDetailPage } from '@/pages/anatel/ProcessDetailPage';
import { AnatelPropositionsPage } from '@/pages/anatel/PropositionsPage';
import { AneelAppealsPage } from '@/pages/aneel/AppealsPage';
import { AneelBiddingPage } from '@/pages/aneel/BiddingPage';
import { AneelCaseDetailPage } from '@/pages/aneel/CaseDetailPage';
import { AneelEntitiesPage } from '@/pages/aneel/EntitiesPage';
import { AneelEntityProfilePage } from '@/pages/aneel/EntityProfilePage';
import { AneelCasesPage } from '@/pages/aneel/CasesPage';
import { AneelCollectionPage } from '@/pages/aneel/CollectionPage';
import { AneelConsistencyPage } from '@/pages/aneel/ConsistencyPage';
import { AneelFeesPage } from '@/pages/aneel/FeesPage';
import { AneelNotificationsPage } from '@/pages/aneel/NotificationsPage';
import { AneelOverviewPage } from '@/pages/aneel/OverviewPage';
import { AneelPenaltiesPage } from '@/pages/aneel/PenaltiesPage';
import { AneelTimelinePage } from '@/pages/aneel/TimelinePage';
import { AnsAppealsPage } from '@/pages/ans/AppealsPage';
import { AnsCaseDetailPage } from '@/pages/ans/CaseDetailPage';
import { AnsCasesPage } from '@/pages/ans/CasesPage';
import { AnsCollectionPage } from '@/pages/ans/CollectionPage';
import { AnsConsistencyPage } from '@/pages/ans/ConsistencyPage';
import { AnsEntitiesPage } from '@/pages/ans/EntitiesPage';
import { AnsEntityProfilePage } from '@/pages/ans/EntityProfilePage';
import { AnsNipPage } from '@/pages/ans/NipPage';
import { AnsOverviewPage } from '@/pages/ans/OverviewPage';
import { AnsPenaltiesPage } from '@/pages/ans/PenaltiesPage';
import { AnsRegimesPage } from '@/pages/ans/RegimesPage';
import { AnsSusPage } from '@/pages/ans/SusPage';
import { AnsTimelinePage } from '@/pages/ans/TimelinePage';
import { BacenAppealsPage } from '@/pages/bacen/AppealsPage';
import { BacenCaseDetailPage } from '@/pages/bacen/CaseDetailPage';
import { BacenCasesPage } from '@/pages/bacen/CasesPage';
import { BacenCollectionPage } from '@/pages/bacen/CollectionPage';
import { BacenConsistencyPage } from '@/pages/bacen/ConsistencyPage';
import { CrsfnAcordaoPage } from '@/pages/bacen/CrsfnAcordaoPage';
import { CrsfnBoardPage } from '@/pages/bacen/CrsfnBoardPage';
import { CrsfnDispositionsPage } from '@/pages/bacen/CrsfnDispositionsPage';
import { CrsfnRelatorPage } from '@/pages/bacen/CrsfnRelatorPage';
import { CrsfnRelatorsPage } from '@/pages/bacen/CrsfnRelatorsPage';
import { CrsfnSearchPage } from '@/pages/bacen/CrsfnSearchPage';
import { CrsfnVotesPage } from '@/pages/bacen/CrsfnVotesPage';
import { BacenEntitiesPage } from '@/pages/bacen/EntitiesPage';
import { BacenEntityProfilePage } from '@/pages/bacen/EntityProfilePage';
import { BacenOverviewPage } from '@/pages/bacen/OverviewPage';
import { BacenPenaltiesPage } from '@/pages/bacen/PenaltiesPage';
import { BacenRegistersPage } from '@/pages/bacen/RegistersPage';
import { BacenSettlementsPage } from '@/pages/bacen/SettlementsPage';
import { BacenTimelinePage } from '@/pages/bacen/TimelinePage';
import { IbamaCaseDetailPage } from '@/pages/ibama/CaseDetailPage';
import { IbamaCasesPage } from '@/pages/ibama/CasesPage';
import { IbamaCollectionPage } from '@/pages/ibama/CollectionPage';
import { IbamaConsistencyPage } from '@/pages/ibama/ConsistencyPage';
import { IbamaDecisionsPage } from '@/pages/ibama/DecisionsPage';
import { IbamaEntitiesPage } from '@/pages/ibama/EntitiesPage';
import { IbamaEntityProfilePage } from '@/pages/ibama/EntityProfilePage';
import { IbamaFeesPage } from '@/pages/ibama/FeesPage';
import { IbamaConamaBoardPage } from '@/pages/ibama/ConamaBoardPage';
import { IbamaConamaReunionPage } from '@/pages/ibama/ConamaReunionPage';
import { IbamaInstrumentsPage } from '@/pages/ibama/InstrumentsPage';
import { IbamaJudgeProfilePage } from '@/pages/ibama/JudgeProfilePage';
import { IbamaJudgesPage } from '@/pages/ibama/JudgesPage';
import { IbamaJudgesMethodologyPage } from '@/pages/ibama/JudgesMethodologyPage';
import { IbamaNotificationsPage } from '@/pages/ibama/NotificationsPage';
import { IbamaOverviewPage } from '@/pages/ibama/OverviewPage';
import { IbamaPenaltiesPage } from '@/pages/ibama/PenaltiesPage';
import { IbamaTimelinePage } from '@/pages/ibama/TimelinePage';
import { CvmAppealsPage } from '@/pages/cvm/AppealsPage';
import { CvmCaseDetailPage } from '@/pages/cvm/CaseDetailPage';
import { CvmCasesPage } from '@/pages/cvm/CasesPage';
import { CvmConsistencyPage } from '@/pages/cvm/ConsistencyPage';
import { CvmDecisionsPage } from '@/pages/cvm/DecisionsPage';
import { CvmDirectorPage } from '@/pages/cvm/DirectorPage';
import { CvmDirectorsPage } from '@/pages/cvm/DirectorsPage';
import { CvmOverviewPage } from '@/pages/cvm/OverviewPage';
import { CvmPartiesPage } from '@/pages/cvm/PartiesPage';
import { CvmPartyPage } from '@/pages/cvm/PartyPage';
import { CvmPipelinePage } from '@/pages/cvm/PipelinePage';
import { CvmSanctionsPage } from '@/pages/cvm/SanctionsPage';
import { CvmSessionsPage } from '@/pages/cvm/SessionsPage';
import { CvmSettlementsPage } from '@/pages/cvm/SettlementsPage';
import { CvmVotesPage } from '@/pages/cvm/VotesPage';
import { AdminOutcomeReviewPage } from '@/pages/admin/OutcomeReviewPage';
import { AdminUsersPage } from '@/pages/admin/UsersPage';
import { ApiKeysPage } from '@/pages/workspace/ApiKeysPage';
import { WorkspacePage } from '@/pages/workspace/WorkspacePage';
import { RequireRole } from '@/components/layout/RequireRole';
import { CadeActivityPage } from '@/pages/cade/ActivityPage';
import { CadeCaseDetailPage } from '@/pages/cade/CaseDetailPage';
import { CadeCasesPage } from '@/pages/cade/CasesPage';
import { CadeCommissionersPage } from '@/pages/cade/CommissionersPage';
import { CadeConselheiroPage } from '@/pages/cade/ConselheiroPage';
import { CadeConsistencyPage } from '@/pages/cade/ConsistencyPage';
import { CadeDecisionsPage } from '@/pages/cade/DecisionsPage';
import { CadeDocumentsPage } from '@/pages/cade/DocumentsPage';
import { CadeCompanyPage } from '@/pages/cade/CompanyPage';
import { CadeOverviewPage } from '@/pages/cade/OverviewPage';
import { CadeSanctionsPage } from '@/pages/cade/SanctionsPage';
import { CadePartiesPage } from '@/pages/cade/PartiesPage';
import { CadePartyProfilePage } from '@/pages/cade/PartyProfilePage';
import { CadeDecisionPage } from '@/pages/cade/DecisionPage';
import { CadeSessionsPage } from '@/pages/cade/SessionsPage';
import { CadeVotesPage } from '@/pages/cade/VotesPage';
import { CadeConselhoPage } from '@/pages/cade/ConselhoPage';
import { CadeAudioPage } from '@/pages/cade/AudioPage';
import { CadeAudioRecordingPage } from '@/pages/cade/AudioRecordingPage';
import { CadeAudioTopicsPage } from '@/pages/cade/AudioTopicsPage';
import { CadeBulletinPage } from '@/pages/cade/BulletinPage';
import { CadeComparePage } from '@/pages/cade/ComparePage';
import { CadePositioningPage } from '@/pages/cade/PositioningPage';
import { CadeDossierPage } from '@/pages/cade/DossierPage';
import { CadeVistaPage } from '@/pages/cade/VistaPage';
import { CadeAudioTranscriptPage } from '@/pages/cade/AudioTranscriptPage';
import { CadeMethodPage } from '@/pages/cade/MethodPage';
import { CadeStartPage } from '@/pages/cade/StartPage';
import { CadeConselhoItemsPage } from '@/pages/cade/ConselhoItemsPage';
import { CadeConselhoCasesPage } from '@/pages/cade/ConselhoCasesPage';
import { CadeConselhoMethodologyPage } from '@/pages/cade/ConselhoMethodologyPage';
import { AnatelSanctionsPage } from '@/pages/anatel/SanctionsPage';

/**
 * The catch-all REDIRECTS rather than 404s, which is convenient and dangerous in
 * equal measure: a link to a route that does not exist lands on a valid-looking
 * page with no console error and no failing request. Two consequences, both
 * learned the hard way in the sibling platform:
 *
 *   - navigation must only ever link to routes defined here (see AppLayout);
 *   - at least one e2e test must navigate by CLICKING and assert on the hrefs
 *     themselves, because `page.goto(url)` never exercises a link.
 */
export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <HomeRedirect /> },
      { path: 'anatel/overview', element: <AnatelOverviewPage /> },
      { path: 'anatel/decisions', element: <AnatelDecisionsPage /> },
      // Detail takes a key and is reached by CLICKING A ROW, never from the
      // menu. `key` is the digits-only process number: the canonical form
      // carries slashes and dots that do not survive a path segment.
      { path: 'anatel/p/:key', element: <AnatelProcessDetailPage /> },
      { path: 'anatel/entities', element: <AnatelEntitiesPage /> },
      { path: 'anatel/sanctions', element: <AnatelSanctionsPage /> },
      { path: 'anatel/consistency', element: <AnatelConsistencyPage /> },
      { path: 'anatel/propositions', element: <AnatelPropositionsPage /> },
      { path: 'anatel/documents', element: <AnatelDocumentsPage /> },
      { path: 'anatel/acordaos', element: <AnatelAcordaosPage /> },
      { path: 'anatel/conselho', element: <AnatelConselhoPage /> },
      // Reached from /anatel/conselho, never from the menu: the record the
      // positions are estimated from.
      { path: 'anatel/conselho/items', element: <AnatelConselhoItemsPage /> },
      // Reached from the bench header and each member block, never from the menu.
      { path: 'anatel/conselho/methodology', element: <AnatelConselhoMethodologyPage /> },
      // Reached by clicking a scope row on /anatel/r/:slug: the cases one
      // severity figure rests on (?member=<slug>&scope=<the metric's scope>).
      { path: 'anatel/conselho/cases', element: <AnatelConselhoCasesPage /> },
      { path: 'anatel/infracoes', element: <AnatelInfracoesPage /> },
      { path: 'anatel/paf', element: <AnatelPafOverviewPage /> },
      { path: 'anatel/paf/decisions', element: <AnatelPafDecisionsPage /> },
      { path: 'anatel/paf/consistency', element: <AnatelPafConsistencyPage /> },
      { path: 'anatel/paf/c/:key', element: <AnatelPafCaseDetailPage /> },
      // Keyed on a slug derived from the person's NAME -- unaccented, lowercased,
      // hyphenated. A person has no number, so the digits-only convention the
      // case routes use cannot apply, and the agency row's uuid is regenerated on
      // every ETL reload. The server recomputes the slugs over BOTH tracks and
      // refuses an ambiguous match rather than opening an arbitrary profile.
      // Reached by clicking a name on /anatel/paf or /anatel/acordaos, never
      // from the menu.
      { path: 'anatel/r/:slug', element: <AnatelConselheiroPage /> },
      // Moved here from 'anatel/paf/r/:slug' when the page widened from PAF
      // relators to the whole Conselho Diretor: four of the sixteen names the
      // acordao dissent table lists have never sat on a fiscal case, so a
      // PAF-scoped URL described a track a quarter of its subjects are not in.
      //
      // An EXPLICIT redirect, not the catch-all below. That one redirects to the
      // overview, so an old link would land on a valid-looking page with a good
      // heading and no error anywhere -- the inherited trap this file already
      // carries an entry for.
      //
      // `handle.redirect` marks this as a route nothing in the app links to
      // ON PURPOSE -- it exists for bookmarks and links already in the wild.
      // Without the marker the reachability test correctly reports it as an
      // orphaned `:param` route, since that test's whole job is to catch a
      // detail page whose list stopped linking to it.
      {
        path: 'anatel/paf/r/:slug',
        // A `loader`, not a redirecting component. Same destination, but the
        // redirect resolves before anything renders -- and a component defined
        // here would make this file export both a component and the router,
        // which is the one thing that breaks Vite's fast refresh for the route
        // table every page depends on.
        loader: ({ params }) => redirect(`/anatel/r/${params.slug}`),
        handle: { redirect: true },
      },
      // Keyed on CNPJ digits: a complete natural key in this corpus (all 7,518
      // entities carry one), and stable across ETL reloads unlike a row uuid.
      { path: 'anatel/e/:cnpj', element: <AnatelEntityProfilePage /> },
      { path: 'aneel/overview', element: <AneelOverviewPage /> },
      { path: 'aneel/cases', element: <AneelCasesPage /> },
      { path: 'aneel/penalties', element: <AneelPenaltiesPage /> },
      { path: 'aneel/consistency', element: <AneelConsistencyPage /> },
      { path: 'aneel/collection', element: <AneelCollectionPage /> },
      // The inspection FEE, not a penalty. Its own route for the same reason
      // `/cade/activity` has one: it reads a different universe from every
      // other ANEEL screen and the two must never be pooled.
      { path: 'aneel/fees', element: <AneelFeesPage /> },
      { path: 'aneel/notifications', element: <AneelNotificationsPage /> },
      { path: 'aneel/timeline', element: <AneelTimelinePage /> },
      // TI and TIPE share one route: both are small, both sit OUTSIDE the
      // Auto de Infração corpus, and neither has a detail page. A TI page
      // would show nothing its row does not already carry.
      { path: 'aneel/bidding', element: <AneelBiddingPage /> },
      // The appeal record: what each instance does with a contested notice,
      // aggregated. Every row links back to `/aneel/cases` through the
      // `first_outcome`/`board_outcome` filters, so the tables and the list
      // count by one predicate.
      { path: 'aneel/appeals', element: <AneelAppealsPage /> },
      // The company directory: every company any track names, by NAME --
      // never by a count, which would rank them. The way into `/aneel/e/:cnpj`
      // for a reader who does not already hold a notice or a fee row.
      { path: 'aneel/entities', element: <AneelEntitiesPage /> },
      // ANEEL deliberately BREAKS the digits-only key convention that
      // `anatel/p/:key` and `cade/c/:key` use. Its notice numbers reduce to only
      // 1,024 distinct digit strings across 1,569 cases, so a digits key would
      // silently open an arbitrary one of up to three different notices. The key
      // here is the notice number with `/` replaced by `~`, which is bijective
      // in this corpus. Percent-encoding the slash instead does NOT work:
      // uvicorn unquotes the path before Starlette routes it, so `%2F` becomes a
      // real separator and this route never matches.
      { path: 'aneel/c/:key', element: <AneelCaseDetailPage /> },
      // Not in the nav: reached by clicking a company. `:cnpj` is the full 14
      // digits, unlike the case route's `~`-escaped notice number.
      { path: 'aneel/e/:cnpj', element: <AneelEntityProfilePage /> },
      // ANS: the penalties ledger keyed on NR_DEMANDA (a digit string unique
      // across the corpus, so the key is the number itself) and the operator
      // directory keyed on the full 14-digit CNPJ.
      { path: 'ans/overview', element: <AnsOverviewPage /> },
      { path: 'ans/cases', element: <AnsCasesPage /> },
      { path: 'ans/appeals', element: <AnsAppealsPage /> },
      { path: 'ans/penalties', element: <AnsPenaltiesPage /> },
      { path: 'ans/collection', element: <AnsCollectionPage /> },
      { path: 'ans/consistency', element: <AnsConsistencyPage /> },
      { path: 'ans/timeline', element: <AnsTimelinePage /> },
      { path: 'ans/nip', element: <AnsNipPage /> },
      { path: 'ans/sus', element: <AnsSusPage /> },
      { path: 'ans/regimes', element: <AnsRegimesPage /> },
      { path: 'ans/entities', element: <AnsEntitiesPage /> },
      { path: 'ans/c/:key', element: <AnsCaseDetailPage /> },
      { path: 'ans/e/:cnpj', element: <AnsEntityProfilePage /> },
      { path: 'ibama/overview', element: <IbamaOverviewPage /> },
      { path: 'ibama/cases', element: <IbamaCasesPage /> },
      { path: 'ibama/decisions', element: <IbamaDecisionsPage /> },
      { path: 'ibama/penalties', element: <IbamaPenaltiesPage /> },
      { path: 'ibama/collection', element: <IbamaCollectionPage /> },
      { path: 'ibama/consistency', element: <IbamaConsistencyPage /> },
      { path: 'ibama/timeline', element: <IbamaTimelinePage /> },
      { path: 'ibama/notifications', element: <IbamaNotificationsPage /> },
      { path: 'ibama/fees', element: <IbamaFeesPage /> },
      { path: 'ibama/instruments', element: <IbamaInstrumentsPage /> },
      { path: 'ibama/entities', element: <IbamaEntitiesPage /> },
      { path: 'ibama/c/:key', element: <IbamaCaseDetailPage /> },
      { path: 'ibama/e/:cnpj', element: <IbamaEntityProfilePage /> },
      { path: 'ibama/judges', element: <IbamaJudgesPage /> },
      { path: 'ibama/judges/methodology', element: <IbamaJudgesMethodologyPage /> },
      { path: 'ibama/j/:slug', element: <IbamaJudgeProfilePage /> },
      { path: 'ibama/conama/board', element: <IbamaConamaBoardPage /> },
      { path: 'ibama/conama/reunion/:reunion', element: <IbamaConamaReunionPage /> },
      { path: 'ibama/conama/r/:slug', element: <IbamaJudgeProfilePage conama /> },
      { path: 'bacen/overview', element: <BacenOverviewPage /> },
      { path: 'bacen/cases', element: <BacenCasesPage /> },
      { path: 'bacen/appeals', element: <BacenAppealsPage /> },
      { path: 'bacen/penalties', element: <BacenPenaltiesPage /> },
      { path: 'bacen/collection', element: <BacenCollectionPage /> },
      { path: 'bacen/consistency', element: <BacenConsistencyPage /> },
      { path: 'bacen/timeline', element: <BacenTimelinePage /> },
      { path: 'bacen/registers', element: <BacenRegistersPage /> },
      { path: 'bacen/settlements', element: <BacenSettlementsPage /> },
      { path: 'bacen/entities', element: <BacenEntitiesPage /> },
      { path: 'bacen/c/:key', element: <BacenCaseDetailPage /> },
      { path: 'bacen/e/:cnpj', element: <BacenEntityProfilePage /> },
      // The CRSFN slice: the acordaos linked to a BACEN ledger row. Five in
      // the nav; the relator and the acordao pages are reached by clicking.
      { path: 'bacen/crsfn/board', element: <CrsfnBoardPage /> },
      { path: 'bacen/crsfn/relators', element: <CrsfnRelatorsPage /> },
      { path: 'bacen/crsfn/r/:slug', element: <CrsfnRelatorPage /> },
      { path: 'bacen/crsfn/votes', element: <CrsfnVotesPage /> },
      { path: 'bacen/crsfn/dispositions', element: <CrsfnDispositionsPage /> },
      { path: 'bacen/crsfn/search', element: <CrsfnSearchPage /> },
      { path: 'bacen/crsfn/a/:key', element: <CrsfnAcordaoPage /> },
      { path: 'cvm/overview', element: <CvmOverviewPage /> },
      { path: 'cvm/cases', element: <CvmCasesPage /> },
      { path: 'cvm/decisions', element: <CvmDecisionsPage /> },
      { path: 'cvm/sanctions', element: <CvmSanctionsPage /> },
      { path: 'cvm/votes', element: <CvmVotesPage /> },
      { path: 'cvm/directors', element: <CvmDirectorsPage /> },
      { path: 'cvm/sessions', element: <CvmSessionsPage /> },
      { path: 'cvm/parties', element: <CvmPartiesPage /> },
      { path: 'cvm/settlements', element: <CvmSettlementsPage /> },
      { path: 'cvm/appeals', element: <CvmAppealsPage /> },
      { path: 'cvm/pipeline', element: <CvmPipelinePage /> },
      { path: 'cvm/consistency', element: <CvmConsistencyPage /> },
      { path: 'cvm/c/:key', element: <CvmCaseDetailPage /> },
      { path: 'cvm/r/:slug', element: <CvmDirectorPage /> },
      { path: 'cvm/parties/:slug', element: <CvmPartyPage /> },
      { path: 'workspace', element: <WorkspacePage /> },
      {
        // Analyst and above, matching the server's gate: a viewer reads the screens and has
        // no use for a key.
        element: <RequireRole roles={['analyst', 'admin', 'superadmin', 'visitante']} />,
        children: [{ path: 'account/api-keys', element: <ApiKeysPage /> }],
      },
      {
        // Superadmin only, matching the server's gate: the nav hides the entry
        // and this redirects anyone who types the URL, so a plain admin never
        // meets the page's 403 error state.
        element: <RequireRole roles={['superadmin']} />,
        children: [{ path: 'admin/users', element: <AdminUsersPage /> }],
      },
      {
        // Admin and superadmin, matching the server's gate (`visitante` is excluded there too).
        element: <RequireRole roles={['admin', 'superadmin']} />,
        children: [{ path: 'admin/outcomes', element: <AdminOutcomeReviewPage /> }],
      },
      { path: 'cade/overview', element: <CadeOverviewPage /> },
      { path: 'cade/method', element: <CadeMethodPage /> },
      { path: 'cade/start', element: <CadeStartPage /> },
      { path: 'cade/audio', element: <CadeAudioPage /> },
      { path: 'cade/compare', element: <CadeComparePage /> },
      { path: 'cade/bulletin', element: <CadeBulletinPage /> },
      { path: 'cade/positioning', element: <CadePositioningPage /> },
      { path: 'cade/vistas', element: <CadeVistaPage /> },
      { path: 'cade/dossier/:key', element: <CadeDossierPage /> },
      { path: 'cade/audio/topics', element: <CadeAudioTopicsPage /> },
      { path: 'cade/audio/:key', element: <CadeAudioRecordingPage /> },
      { path: 'cade/audio/:key/transcript', element: <CadeAudioTranscriptPage /> },
      { path: 'cade/cases', element: <CadeCasesPage /> },
      // A DIFFERENT population from every other CADE route: CADE's own
      // published case universe (8,107 processes) rather than the tribunal
      // session archive (464 adjudicated cases). Its own page for that reason.
      { path: 'cade/activity', element: <CadeActivityPage /> },
      { path: 'cade/decisions', element: <CadeDecisionsPage /> },
      { path: 'cade/documents', element: <CadeDocumentsPage /> },
      { path: 'cade/company', element: <CadeCompanyPage /> },
      { path: 'cade/company/:root', element: <CadeCompanyPage /> },
      { path: 'cade/consistency', element: <CadeConsistencyPage /> },
      { path: 'cade/commissioners', element: <CadeCommissionersPage /> },
      { path: 'cade/sanctions', element: <CadeSanctionsPage /> },
      { path: 'cade/sessions', element: <CadeSessionsPage /> },
      { path: 'cade/votes', element: <CadeVotesPage /> },
      { path: 'cade/conselho', element: <CadeConselhoPage /> },
      { path: 'cade/conselho/items', element: <CadeConselhoItemsPage /> },
      { path: 'cade/conselho/methodology', element: <CadeConselhoMethodologyPage /> },
      // Reached by clicking a figure, never from the menu (?metric=&name=&other=).
      { path: 'cade/conselho/cases', element: <CadeConselhoCasesPage /> },
      // One decision, by its natural key. Reached from the votes index, a
      // dissent row, a search hit or a case card -- never from the nav.
      { path: 'cade/votes/d/:key', element: <CadeDecisionPage /> },
      // In the nav. The population is the SESSION ARCHIVE's 3,209 parties, not
      // the 16,423 rows in `parties`: the rest arrive from CADE's published
      // registry and are named on no tribunal decision.
      { path: 'cade/parties', element: <CadePartiesPage /> },
      // Keyed on the digits-only case number: `08012.007505/2002-48` carries dots
      // and a slash that do not survive a path segment, and all 464 cases stay
      // distinct once stripped. Reached by CLICKING A ROW, never from the menu.
      { path: 'cade/c/:key', element: <CadeCaseDetailPage /> },
      // Keyed on the accent-folded canonical name: the 17 relatores give 17
      // distinct slugs, and the fold happens in SQL beside the column that owns
      // the name. Reached by CLICKING A NAME, never from the menu -- there is no
      // one conselheiro for a menu entry to point at.
      { path: 'cade/r/:slug', element: <CadeConselheiroPage /> },
      // Keyed on the accent-folded `name_canonical`: all 16,423 party names give
      // 16,423 distinct non-empty slugs, verified 2026-09-10. `parties.id` and
      // `canonical_cluster_id` are uuids every ETL reload regenerates and can
      // never be a URL key. Reached by CLICKING A NAME; the list at
      // `/cade/parties` is what the menu points at.
      { path: 'cade/parties/:slug', element: <CadePartyProfilePage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
